import { render } from "./Microphone.vue.js?vue&type=template&id=0165d06b!=!../vue-loader/dist/index.js??ruleSet[0]!./Microphone.vue?vue&type=template&id=0165d06b"
import script from "./Microphone.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./Microphone.vue?vue&type=script&lang=js"
export * from "./Microphone.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./Microphone.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__